<h5>Plan caducado</h5>
<p>
  La fecha de finalización de este plan ya pasó. Puedes prorrogarlo o iniciar el cierre para abrir el siguiente plan.
</p>

<div class="w-full flex flex-row items-center gap-2 pt-3 flex-wrap">
  <button (click)="choose('extend')"
          class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Prorrogar" class="h-4 filter-primary-600" src="/assets/icons/feather/clock.svg">
    <span class="cd-text-md truncate">Prorrogar</span>
  </button>

  <button (click)="choose('close')"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Cerrar plan" class="h-4 filter-neutral-100" src="/assets/icons/feather/check-circle.svg">
    <span class="cd-text-md truncate">Cerrar y Evaluar</span>
  </button>
</div>
